import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    menuLists: {},
  }
}

const state = getDefaultState()

const mutations = {
  SET_MENU_LISTS(state, payload) {
    state.menuLists = payload
  },
}

const actions = {
  async getMenuList({ commit }, payload) {
    const apiResult = await apiService.get(route('member.menu'), payload)
    if (apiResult && apiResult.data) {
      commit('SET_MENU_LISTS', apiResult.data)
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
